import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { IconVariant } from '../constants/icons'
import { ClassesType } from '../types'
import { capitalize } from '../utils/languageUtils'

const useStyles = makeStyles(
  theme => ({
    circle: {},
    path: {},
    circlePrimary: {
      fill: theme.colors.planBranding,
    },
    pathPrimary: {
      fill: theme.colors.profileText,
    },
    circleSecondary: {
      fill: theme.colors.secondaryText,
    },
    pathSecondary: {
      fill: theme.colors.profileText,
    },
    circleDisabled: {
      fill: theme.colors.defaultAvatarBackground,
    },
    pathDisabled: {
      fill: theme.colors.profileText,
    },
    circleWarning: {
      fill: theme.colors.actionNeededBackground,
    },
    pathWarning: {
      fill: theme.colors.planWarning,
    },
    circleInactive: {
      fill: theme.colors.inactiveBackground,
    },
    pathInactive: {
      fill: theme.colors.profileText,
    },
    circleSuspensed: {
      fill: theme.colors.actionNeededBackground,
    },
    pathSuspensed: {
      fill: theme.colors.planSuspensed,
    },
    circlePaused: {
      fill: theme.colors.important,
    },
    pathPaused: {
      fill: theme.colors.profileText,
    },
  }),
  { name: 'Boop' },
)

export interface BoopProps extends SvgIconProps {
  readonly classes?: ClassesType<typeof useStyles>
  readonly variant?: IconVariant
}

const Boop = forwardRef<SVGSVGElement, BoopProps>(function Boop(
  { classes: classesProp, variant = IconVariant.PRIMARY, ...rest },
  ref,
) {
  const classes = useStyles({ classes: classesProp })

  const variantClass = capitalize(variant)
  const circleClass = classes[`circle${variantClass}`]
  const pathClass = classes[`path${variantClass}`]

  return (
    <SvgIcon ref={ref} {...rest} viewBox="-1 -1 24 24">
      <circle
        className={classNames(classes.circle, circleClass)}
        cx="11"
        cy="11"
        r="11"
      />
      <path
        className={classNames(classes.path, pathClass)}
        d="M9.99 12.03l.42 2.49 2.05-.38c1.13-.2 1.56-.75 1.42-1.56-.14-.8-.63-1.16-1.89-.92l-2 .37zm-.8-4.8l.37 2.27 2.12-.4c1.03-.19 1.33-.74 1.22-1.42-.12-.7-.6-1.03-1.62-.84l-2.1.39zm-2.03 7.85l.43-.08-1.22-7.25-.43.08a.58.58 0 01-.67-.5L5 5.82a.6.6 0 01.47-.7l5.23-.97c2.93-.54 4.64.44 5.04 2.83a2.86 2.86 0 01-.81 2.7c1.04.39 1.7 1.2 1.93 2.49.44 2.65-1.1 4.17-4.02 4.71l-5.23.97a.58.58 0 01-.67-.5L6.7 15.8a.6.6 0 01.47-.7z"
      />
    </SvgIcon>
  )
})

export default Boop
